// Libs
import React from 'react';
import { Container, Form, FormCheck } from 'react-bootstrap';

//-------------------------------------------------------------------------------------------------------------------

class FormChecks extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: !!props.isOpenByDefault
        };
    }

    toggleAllNone(isSelected) {
        const { options, onChange } = this.props;
        const values = {};
        for (let i = 0; i < options.length; i++) {
            values[options[i].id] = isSelected;
        }
        onChange(values);
    }

    render() {
        const { isScrolling, includeFormGroup, className, name, allowSelectAllNone, isConcertina, options, value, id } = this.props;
        const { isOpen } = this.state;

        // Determine status of all/none checkbox
        let areAllSelected = true;
        let areSomeSelected = false;
        let numSelected = 0;
        if (allowSelectAllNone) {
            for (let i = 0; i < options.length; i++) {
                const option = options[i];
                if (value[option.id]) {
                    areSomeSelected = true;
                    numSelected++;
                } else {
                    areAllSelected = false;
                }
            }
            setTimeout(() => {
                const checkbox = document.getElementById(`${id}-all`);
                if (checkbox) {
                    checkbox.indeterminate = (areSomeSelected && !areAllSelected);
                }
            }, 0);
        }

        // Add scrolling
        let content = this.renderInner(areAllSelected);
        if (isScrolling) {
            content = (
                <div className="scrolling-form-checks">
                    {content}
                </div>
            );
        }

        // Add form group
        if (includeFormGroup) {
            content = (
                <Form.Group className={'form-checks ' + (className || '')}>
                    <Form.Label className={(isConcertina ? 'concertina-label' : '')} onClick={() => {
                        if (isConcertina) {
                            this.setState({ isOpen: !this.state.isOpen });
                        }
                    }}>
                        {name} ({numSelected} selected)
                        {isConcertina &&
                            <span className={`concertina-icon fa-solid ${isOpen ? 'fa-circle-minus' : 'fa-circle-plus'}`} />
                        }
                    </Form.Label>
                    {(!isConcertina || isOpen) &&
                        <div>
                            {content}
                        </div>
                    }
                </Form.Group>
            );
        }

        return content;
    }
    
    renderInner(areAllSelected) {
        const { id, options, value, onChange, getLabel, allowSelectAllNone } = this.props;

        return (<>

            {allowSelectAllNone && <>
                <Form.Check
                    className="select-all-none"
                    id={`${id}-all`}
                    label={`Select all/none (${options.length})`}
                    checked={areAllSelected}
                    onChange={() => this.toggleAllNone(!areAllSelected)}
                />
            </>}

            {options.map(o =>
                <Form.Check
                    key={o.id}
                    id={`${id}-${o.id}`}
                    label={getLabel ? getLabel(o) : o.name}
                    checked={value[o.id] || false}
                    onChange={e => onChange({ [o.id]: e.target.checked })}
                />
            )}
        </>);
    }
}

export default FormChecks;